// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

function floatToDate(param) {
  return Relude_Globals.$great$great((function (param) {
                return 1000.0 * param;
              }), (function (prim) {
                return new Date(prim);
              }), param);
}

function dateToFloat(x) {
  return x.getTime() / 1000.0;
}

exports.floatToDate = floatToDate;
exports.dateToFloat = dateToFloat;
/* Relude_Globals Not a pure module */
